import { URL_PATHS } from '@constants'
import { useIsMobile } from '@hooks/useIsMobile'
import { useStore } from '@hooks/useStore'
import { GridRow, GridRowParams } from '@mui/x-data-grid'
import { observer } from 'mobx-react-lite'
import { useCallback, useMemo } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { OvDataGrid } from 'src/components/core/ov-data-grid/ov-data-grid'
import { MobileDocumentRow } from 'src/partials/index.partials'

export const OvClientQuotationsTab = observer(() => {
  const { quotation } = useStore()
  const isMobile = useIsMobile()
  const { id } = useParams()
  const navigate = useNavigate()

  const handleRowClick = (params: GridRowParams) => {
    if (!params.id) return
    const path = generatePath(URL_PATHS.QUOTE_DETAIL, { id: params.id })
    return navigate(path)
  }

  const getDefaultParams = useMemo(() => {
    const params: Record<string, any> = {}
    if (id) {
      const _id = parseInt(id)
      params['client_id'] = _id
    }
    return params
  }, [id])

  const CustomRow = useCallback(
    (props: any) =>
      isMobile ? (
        <MobileDocumentRow
          {...props.row}
          type="quotation"
          onRowClick={handleRowClick}
        />
      ) : (
        <GridRow {...props} />
      ),
    [isMobile, handleRowClick]
  )

  return (
    <OvDataGrid
      slots={{
        row: CustomRow,
      }}
      onRowClick={handleRowClick}
      store={quotation.data_grid}
      responsiveColumns
      params={getDefaultParams}
      {...(isMobile && {
        autoHeight: true,
        getEstimatedRowHeight: () => 109,
        getRowHeight: () => 'auto',
      })}
    />
  )
})
